module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_main_preview.55cb1867.jpg";